<template>
  <div>
    <div
      @dblclick="openDoc(data.docId, data.docErr)"
      @click="startStopDoc(data)"
      class="d-flex accordion-row auto-txt-holder"
    >
      <div>
        <h6>
          {{ checkCarName(data.rowName) }}
          {{ data.docName }}
        </h6>
        <h6 v-if="data.reason" class="reason-txt">
          {{ data.reason }}
        </h6>
      </div>
      <div class="flex-grow-0">
        <v-avatar
          class="status-row"
          v-if="data.documentOnPause == 1"
          size="25px"
          tile
        >
          <i aria-hidden="true" class="v-icon material-icons">pause</i>
        </v-avatar>
        <v-avatar
          class="status-row"
          v-if="data.documentIsCompleted === 1"
          size="25px"
          tile
        >
          <i aria-hidden="true" class="v-icon material-icons">stop</i>
        </v-avatar>
        <div class="blink-area" v-if="data.documentIsStarted === 1"></div>
      </div>
    </div>
    <div class="data-table-holder">
      <v-data-table
        :headers="worksHeaders"
        :items="data.rowList"
        hide-headers
        hide-actions
        class="elevation-1"
        ref="dataTable"
      >
        <template slot="items" slot-scope="props">
          <tr
            @click="activateRow(props.item)"
            class="tab-row tr-"
            :class="{ 'active-work-row': props.item.isActive === 1 }"
            :key="props.item.rowName"
          >
            <td class="table-col-small text-xs-left">
              {{ props.item.startTime }}
            </td>
            <td class="table-col-small text-xs-left">
              {{ props.item.endTime }}
            </td>
            <td class="text-xs-left">
              {{ props.item.rowName }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="actionDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline"> Начать работы по документу? </span>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="actionDialog = false">
            {{ $t('global.close') }}
          </v-btn>
          <v-btn @click="actionDialogOK()">
            <h5>Ok</h5>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-dialog
      ref="confirmDialogModal"
      @actionСonfirmed="confirmDialogOK"
    />
  </div>
</template>

<script>
import router from '@/router'
import i18n from '@/plugins/i18n'
import { WorkPlanFunctionsMixin } from '../WorkPlanFunctionsMixin.js'

export default {
  name: 'DateDetails',
  props: {
    data: {
      type: Object,
      required: true,
    },
    workPlan: {
      type: Array,
    },
  },
  mixins: [WorkPlanFunctionsMixin],
  components: {
    'confirm-dialog': () => import('../ConfirmDialog.vue'),
  },
  data: function() {
    return {
      currentId: '',
      rowTimeoutId: -1,
      actionDialog: false,
      actionDialogData: undefined,
      worksHeaders: [
        {
          text: 'Начало',
          value: 'startTime',
          align: 'center',
          class: 'table-col-small',
        },
        {
          text: 'Окончание',
          value: 'endTime',
          align: 'center',
          class: 'table-col-small',
        },
        { text: 'Работа', value: 'rowName', align: 'left' },
        { text: 'Статус', value: 'rowName', align: 'right' },
      ],
    }
  },
  methods: {
    checkCarName(name) {
      return name || this.workPlanTexts.carIsEmpty
    },
    showConfirmDialog(dialogData) {
      this.$refs.confirmDialogModal.show(dialogData)
    },
    activateRow(docData, actionDialogConfirmed = false) {
      if (!docData.docId) {
        return
      }
      if (docData.completed) {
        return
      }
      if (!docData.documentIsStarted && !actionDialogConfirmed) {
        this.actionDialog = true
        this.actionDialogData = docData
        return
      }

      if (docData.err) {
        this.$store.dispatch('showSnackMessage', {
          color: 'error',
          text: docData.err,
        })
      } else if (docData.docId && docData.workID) {
        if (docData.oneClickComplete === 1) {
          this.startStopDoc_(docData)
        } else if (!docData.documentIsStarted) {
          this.startWorks(docData.docId, docData.workID).then(res => {
            if (res) {
              docData.documentIsStarted = 1
              this.setRowStatus_(docData)
            }
          })
        } else {
          this.setRowStatus_(docData)
        }
      }
    },
    setRowStatus_(docData) {
      let status = docData.isActive === 1 ? 0 : 1
      this.setRowStatus(docData.docId, docData.workID, status).then(resp => {
        if (resp !== false) {
          this.setDocState(Object.assign(docData, { isActive: status }))
        }
      })
    },
    setIndication(id) {
      this.setDocState({ docId: id, state: 1, completed: 0, pause: 0 })
    },
    stopIndication(id, completed, pause) {
      this.setDocState({ docId: id, state: 0, completed, pause })
    },
    setDocState(docData) {
      // setDocState(id, state, completed, pause, workID, isActive) {
      if (!docData.docId) return
      this.workPlan.forEach(elDate => {
        elDate.rowList.forEach(elAuto => {
          if (elAuto.docId === docData.docId) {
            elAuto.documentIsStarted = docData.documentIsStarted
            elAuto.documentIsCompleted = docData.completed
            if (docData.documentIsStarted === 1 || docData.completed === 1) {
              elAuto.documentOnPause = 0
            } else {
              elAuto.documentOnPause = docData.pause
            }
          }
          elAuto.rowList.forEach(elWork => {
            if (elWork.docId === docData.docId) {
              elWork.documentIsStarted = docData.documentIsStarted
              elWork.documentIsCompleted = docData.completed
              if (docData.documentIsStarted === 1 || docData.completed === 1) {
                elWork.documentOnPause = 0
              } else {
                elWork.documentOnPause = docData.pause
              }
            }
            if (elWork.docId === docData.docId)
              elWork.documentIsStarted = docData.documentIsStarted
            if (
              elWork.docId === docData.docId &&
              docData.documentIsStarted == 0
            ) {
              elWork.isActive = 0
            } else {
              if (
                elWork.workID === docData.workID &&
                elWork.docId === docData.docId
              )
                elWork.isActive = docData.isActive
            }
          })
        })
      })
    },
    confirmDialogOK(dialogData) {
      if (dialogData.dialogID === 'closePreviousDocument') {
        if (dialogData.action === 2) {
          this.stopWorks(1, dialogData.previousDocument).then(() => {
            this.startWorks(this.currentId).then()
          })
        } else {
          this.stopWorks(0, dialogData.previousDocument).then(() => {
            this.startWorks(this.currentId).then()
          })
        }
      } else if (dialogData.dialogID === 'closeCurrentDocument') {
        if (dialogData.action === 2) {
          this.stopWorks(1, dialogData.previousDocument).then(() => {})
        } else {
          this.stopWorks(0, dialogData.previousDocument).then(() => {})
        }
      }
    },
    actionDialogOK() {
      if (this.actionDialogData.startDoc) {
        this.startStopDoc(this.actionDialogData, true)
      } else {
        this.activateRow(this.actionDialogData, true)
      }
      this.actionDialog = false
      this.actionDialogData = undefined
    },
    openDoc(id, err) {
      if (this.rowTimeoutId !== -1) {
        clearTimeout(this.rowTimeoutId)
        this.rowTimeoutId = -1
      }
      if (err) {
        this.$store.dispatch('showSnackMessage', { color: 'error', text: err })
      } else if (id) {
        this.dialog = false
        router.push({ path: `/doczn/${id}` })
      }
    },
    startStopDoc(docData, actionDialogConfirmed = false) {
      if (!docData.docId) {
        return
      }
      if (docData.completed) {
        return
      }
      if (!docData.documentIsStarted && !actionDialogConfirmed) {
        this.actionDialog = true
        this.actionDialogData = Object.assign(docData, { startDoc: true })
        return
      }

      if (this.rowTimeoutId === -1) {
        this.rowTimeoutId = setTimeout(() => {
          this.startStopDoc_(docData)
        }, 500)
      }
    },
    startStopDoc_(docData) {
      this.rowTimeoutId = -1
      this.currentId = docData.docId
      if (docData.err) {
        this.$store.dispatch('showSnackMessage', {
          color: 'error',
          text: docData.err,
        })
      } else if (docData.docId) {
        var dialogData = {
          docId: docData.docId,
          number: docData.docNumber,
          description: docData.rowName,
          rowData: undefined,
        }
        if (docData.oneClickComplete === 1) {
          dialogData.onlyComplete = true
          this.stopWorks(true, docData.docId, dialogData)
        } else if (!docData.documentIsStarted) {
          this.startWorks(docData.docId)
        } else {
          this.stopWorks(false, docData.docId, dialogData)
        }
      }
    },
  },
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
    workPlanTexts: function() {
      return i18n.messages[i18n.locale].workPlan
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../_scss/mixins';
.blink-area {
  -webkit-animation: blink 1s linear infinite;
  animation: blink 1s linear infinite;
  width: 10px;
  height: 10px;
  margin: 3px 10px 10px 10px;
}
@-webkit-keyframes blink {
  0% {
    background: rgb(192, 22, 22);
  }
  100% {
    background: rgba(192, 22, 22, 0.2);
  }
}
@keyframes blink {
  0% {
    background: rgb(192, 22, 22);
  }
  100% {
    background: rgba(192, 22, 22, 0.2);
  }
}
.status-row {
  margin: 0;
}
.accordion-row:hover {
  text-decoration: none;
  background: rgb(102, 80, 80);
}
.accordion-row h5 {
  margin-top: 2px;
}
.active-row {
  background: rgb(102, 80, 80);
}
.date-txt-holder {
  margin-left: 5px;
}
.row-avatar {
  padding: 0 0 5px 0;
}
.auto-txt-holder {
  margin: 0px 5px;
  min-height: 40px;
  padding: 10px 0 0 0;
}
.reason-txt {
  font-size: 0.85em;
}
.data-table-holder {
  border-width: 1px;
  padding: 5px 5px;
  border-style: dotted;
  border-color: coral;
}
.active-work-row {
  background: rgb(91, 163, 82) !important;
}
</style>
